import React from 'react'
import { Button, Form } from 'react-bootstrap'

function Driving_School_Details() {
    return (
        <>
            <section className='Personal_Details'>
                <Form>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Name of your Driving School</Form.Label>
                        <Form.Control placeholder="Enter Name of your Driving School" />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Your RTO</Form.Label>
                        <Form.Control placeholder="Enter Your RTO" />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Vendor Code</Form.Label>
                        <Form.Control placeholder="Enter Vendor Code" />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>GST No.</Form.Label>
                        <Form.Control placeholder="Enter GST No." />
                    </Form.Group>
                    <div className='text-center'>

                        <Button className="search_btn" type="submit">
                            Save Changes
                        </Button>
                    </div>

                </Form>
            </section>
        </>
    )
}

export default Driving_School_Details